(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3258],{

/***/ 43518:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programa-de-socios",
      function () {
        return __webpack_require__(92181);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Check; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Check/Check.js



var defaultProps = {
    size: "w-6 h-6",
    className: null
};
var propTypes = {
    size: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Check(param) {
    var size = param.size, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (0,clsx_m/* default */.Z)(size, className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            clipRule: "evenodd"
        })
    });
};
Check.defaultProps = defaultProps;
Check.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Check/index.js

/* harmony default export */ var components_Check = (Check);


/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 59679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Lead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Lead/Lead.js




var defaultProps = {
    muted: true,
    className: null
};
var propTypes = {
    muted: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function Lead(param) {
    var muted = param.muted, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)("text-lg font-normal leading-normal lg:text-xl", muted && "text-gray-600", className),
        children: children
    });
};
Lead.defaultProps = defaultProps;
Lead.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Lead/index.js

/* harmony default export */ var components_Lead = (Lead);


/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 82639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ ScrollSpyItem; },
  "Z": function() { return /* binding */ ScrollSpy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@makotot/ghostui/dist/ghostui.esm.js
var ghostui_esm = __webpack_require__(26367);
;// CONCATENATED MODULE: ./src/components/ScrollSpy/ScrollSpy.js






var defaultProps = {
    className: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function ScrollSpyComponent(_param) {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ghostui_esm/* Scrollspy */.ie, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, props), {
        children: children
    }));
};
ScrollSpyComponent.defaultProps = defaultProps;
ScrollSpyComponent.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/ScrollSpy/ScrollSpyItem.js






var ScrollSpyItem_defaultProps = {
    className: null,
    targetClassName: null
};
var ScrollSpyItem_propTypes = {
    anchor: (prop_types_default()).string.isRequired,
    label: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    targetClassName: (prop_types_default()).string
};
function ScrollSpyItem(_param) {
    var anchor = _param.anchor, label = _param.label, className = _param.className, targetClassName = _param.targetClassName, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "anchor",
        "label",
        "className",
        "targetClassName"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: "#".concat(anchor),
            className: (0,clsx_m/* default */.Z)("whitespace-nowrap text-base lg:text-lg", targetClassName, className)
        }, rest), {
            children: label
        }))
    });
};
ScrollSpyItem.defaultProps = ScrollSpyItem_defaultProps;
ScrollSpyItem.propTypes = ScrollSpyItem_propTypes;

;// CONCATENATED MODULE: ./src/components/ScrollSpy/index.js


/* harmony default export */ var ScrollSpy = (ScrollSpyComponent);



/***/ }),

/***/ 77276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SubHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/DynamicPropsInjection/index.js + 3 modules
var DynamicPropsInjection = __webpack_require__(2183);
// EXTERNAL MODULE: ./src/shapes/index.js + 16 modules
var shapes = __webpack_require__(71634);
;// CONCATENATED MODULE: ./src/components/Spacing/Spacing.js







var defaultProps = {
    horizontal: null,
    vertical: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    type: "m",
    inject: false,
    className: "",
    children: null
};
var propTypes = {
    horizontal: shapes/* ShapeSpacing */.N0,
    vertical: shapes/* ShapeSpacing */.N0,
    top: shapes/* ShapeSpacing */.N0,
    bottom: shapes/* ShapeSpacing */.N0,
    left: shapes/* ShapeSpacing */.N0,
    right: shapes/* ShapeSpacing */.N0,
    type: prop_types_default().oneOf([
        "m",
        "p"
    ]),
    inject: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Spacing(_param) {
    var horizontal = _param.horizontal, vertical = _param.vertical, top = _param.top, bottom = _param.bottom, left = _param.left, right = _param.right, type = _param.type, inject = _param.inject, className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "horizontal",
        "vertical",
        "top",
        "bottom",
        "left",
        "right",
        "type",
        "inject",
        "className",
        "children"
    ]);
    var classes = [
        className
    ];
    if (horizontal || left === right && left !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "x-").concat(horizontal || left)
        ]);
    } else {
        if (left !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "l-").concat(left)
            ]);
        }
        if (right !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "r-").concat(right)
            ]);
        }
    }
    if (vertical || top === bottom && top !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "y-").concat(vertical || top)
        ]);
    } else {
        if (top !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "t-").concat(top)
            ]);
        }
        if (bottom !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "b-").concat(bottom)
            ]);
        }
    }
    var content;
    if (!inject) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        });
    } else {
        content = children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPropsInjection/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes),
        props: rest,
        children: content
    });
};
Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;


;// CONCATENATED MODULE: ./src/components/Spacing/index.js

/* harmony default export */ var components_Spacing = (Spacing);


// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
;// CONCATENATED MODULE: ./src/components/SubHeading/SubHeading.js






var SubHeading_defaultProps = {
    color: "text-green-500"
};
var SubHeading_propTypes = {
    heading: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
function SubHeading(param) {
    var heading = param.heading, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Spacing, {
        bottom: 4,
        inject: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            padding: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (0,clsx_m/* default */.Z)("inline-flex text-xl font-semibold leading-none tracking-tight", color),
                children: heading
            })
        })
    });
};
SubHeading.defaultProps = SubHeading_defaultProps;
SubHeading.propTypes = SubHeading_propTypes;

;// CONCATENATED MODULE: ./src/components/SubHeading/index.js

/* harmony default export */ var components_SubHeading = (SubHeading);


/***/ }),

/***/ 37346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Text/Text.js




var defaultProps = {
    muted: false,
    xsmall: false,
    small: false,
    large: false,
    medium: false,
    semibold: false,
    className: "",
    children: ""
};
var propTypes = {
    muted: (prop_types_default()).bool,
    xsmall: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    large: (prop_types_default()).bool,
    medium: (prop_types_default()).bool,
    semibold: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Text(param) {
    var muted = param.muted, xsmall = param.xsmall, small = param.small, large = param.large, medium = param.medium, semibold = param.semibold, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, {
            "text-gray-500": muted,
            "text-xs": xsmall,
            "text-sm": small,
            "text-lg": large,
            "font-medium": medium,
            "font-semibold": semibold
        }),
        children: children
    });
};
Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Text/index.js

/* harmony default export */ var components_Text = (Text);


/***/ }),

/***/ 23638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ domain_CustomerLogos; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/domain/CustomerLogos/CustomerLogos.js







var defaultProps = {
    className: "lg:px-20",
    customers: []
};
var propTypes = {
    className: (prop_types_default()).string,
    customers: prop_types_default().arrayOf(prop_types_default().shape({
        logo: (prop_types_default()).string,
        title: (prop_types_default()).string,
        url: (prop_types_default()).string
    }))
};
function CustomerLogos(param) {
    var className = param.className, customers = param.customers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        className: (0,clsx_m/* default */.Z)(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 justify-center",
                children: customers.map(function(param, idx) {
                    var logo = param.logo, title = param.title, url = param.url;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: typeof logo === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                            src: logo,
                            alt: title,
                            width: 300,
                            height: 190
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                            title: title
                        }, logo))
                    }, "customer-logo-".concat(idx, "-with-").concat(url));
                })
            })
        })
    });
};
CustomerLogos.defaultProps = defaultProps;
CustomerLogos.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/CustomerLogos/index.js

/* harmony default export */ var domain_CustomerLogos = (CustomerLogos);


/***/ }),

/***/ 77390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ udla; },
/* harmony export */   "O2": function() { return /* binding */ nestleSimple; },
/* harmony export */   "P$": function() { return /* binding */ iess; },
/* harmony export */   "Vq": function() { return /* binding */ modernaAlimentos; },
/* harmony export */   "az": function() { return /* binding */ procredit; },
/* harmony export */   "bR": function() { return /* binding */ soltein; },
/* harmony export */   "el": function() { return /* binding */ soyHincha; },
/* harmony export */   "pQ": function() { return /* binding */ nestle; },
/* harmony export */   "tP": function() { return /* binding */ technisys; }
/* harmony export */ });
/* unused harmony exports stackbuilders, salica, klever, farmaenlace, megaprofer */
var iess = {
    logo: "v1642656757/clientes/iess_jov8bv.png",
    title: "Instituto Ecuatoriano de Seguridad Social",
    url: "https://www.iess.gob.ec/"
};
var nestle = {
    logo: "v1642656870/clientes/nestle_dgfaal.png",
    title: "Nestle Ecuador",
    url: "https://www.nestle.com.ec/"
};
var nestleSimple = {
    logo: "v1642656903/clientes/nestle-simple_j6jz9n.png",
    title: "Nestle Ecuador",
    url: "https://www.nestle.com.ec/"
};
var soltein = {
    logo: "v1610716328/clientes/soltein_xie3pe.png",
    title: "Soltein",
    url: "https://www.soltein.net/"
};
var soyHincha = {
    logo: "v1610716328/clientes/soy-hincha_rualzx.png",
    title: "Soy Hincha",
    url: "https://www.soyhincha.com/"
};
var udla = {
    logo: "v1642656789/clientes/udla_ljwmwd.png",
    title: "Universidad de las Am\xe9ricas",
    url: "https://www.udla.edu.ec/"
};
var modernaAlimentos = {
    logo: "v1642656833/clientes/moderna-alimentos_s8ibnv.png",
    title: "Alimentos Moderna",
    url: "https://www.moderna.com.ec/"
};
var stackbuilders = {
    logo: "v1615002897/clientes/stackbuilders_b5h22c.png",
    title: "Stack Builders"
};
var technisys = {
    logo: "v1642492527/clientes/technisys_tpocwc.png",
    title: "Technisys"
};
var salica = {
    logo: "v1642492527/clientes/salica_vjaqro.png",
    title: "Salica"
};
var klever = {
    logo: "v1642494547/clientes/klever_pweeo6.png",
    title: "Klever Team"
};
var farmaenlace = {
    logo: "v1642492527/clientes/farmaenlace_bamb3a.png",
    title: "Farmaenlace"
};
var megaprofer = {
    logo: "v1642492965/clientes/megaprofer_tafkg9.png",
    title: "Megaprofer"
};
var procredit = {
    logo: "v1642656694/clientes/banco-procredit_e89oem.png",
    title: "Banco ProCredit"
};


/***/ }),

/***/ 11083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// React hook for delaying calls with time
// returns callback to use for cancelling
function useTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var timeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var cancel = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var timeoutId = timeoutIdRef.current;
        if (timeoutId) {
            timeoutIdRef.current = undefined;
            clearTimeout(timeoutId);
        }
    }, [
        timeoutIdRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        timeoutIdRef.current = setTimeout(callback, timeout);
        return cancel;
    }, [
        callback,
        timeout,
        cancel
    ]);
    return cancel;
};


/***/ }),

/***/ 92181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PartnersProgramPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/SubHeading/index.js + 3 modules
var SubHeading = __webpack_require__(77276);
// EXTERNAL MODULE: ./src/components/ScrollSpy/index.js + 2 modules
var ScrollSpy = __webpack_require__(82639);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/SecondaryTitle/SecondaryTitle.js



var defaultProps = {
    level: 2,
    className: "",
    fontSize: "text-4xl"
};
var propTypes = {
    level: prop_types_default().oneOf([
        2,
        3
    ]),
    className: (prop_types_default()).string,
    fontSize: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function SecondaryTitle(param) {
    var level = param.level, className = param.className, fontSize = param.fontSize, children = param.children;
    var Level = "h".concat(level);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Level, {
        className: (0,clsx_m/* default */.Z)(fontSize, "font-semibold leading-tight tracking-tight", className),
        children: children
    });
};
SecondaryTitle.defaultProps = defaultProps;
SecondaryTitle.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/SecondaryTitle/index.js

/* harmony default export */ var components_SecondaryTitle = (SecondaryTitle);

// EXTERNAL MODULE: ./src/components/Lead/index.js + 1 modules
var Lead = __webpack_require__(59679);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/components/LinkMore/LinkMore.js




var LinkMore_defaultProps = {
    children: "Conocer m\xe1s",
    className: ""
};
var LinkMore_propTypes = {
    href: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node,
    className: (prop_types_default()).string
};
function LinkMore(param) {
    var href = param.href, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        href: href,
        className: (0,clsx_m/* default */.Z)("inline-flex items-center transition duration-100 ease-in-out", "space-x-1 text-lg font-medium text-green-500", "hover:text-gray-900", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "h-4 w-4",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
};
LinkMore.defaultProps = LinkMore_defaultProps;
LinkMore.propTypes = LinkMore_propTypes;

;// CONCATENATED MODULE: ./src/components/LinkMore/index.js

/* harmony default export */ var components_LinkMore = (LinkMore);

// EXTERNAL MODULE: ./src/components/Check/index.js + 1 modules
var Check = __webpack_require__(29468);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/hooks/useHover.js
var useHover = __webpack_require__(82163);
;// CONCATENATED MODULE: ./src/domain/Partners/PartnersApplicationSteps.js





function PartnersApplicationStepBullet(param) {
    var step = param.step, isActive = param.isActive, isHover = param.isHover;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center w-12 h-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)("rounded-full border-2 flex items-center justify-center transition ease-in-out duration-300", isActive === false && "w-10 h-10", isActive === true && "w-12 h-12 border-green-500", isActive === false && isHover === false && "border-gray-300", isActive === false && isHover === true && "border-green-500"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("rounded-full transition ease-in-out duration-300 flex items-center justify-center", isActive === false && "w-6 h-6", isActive === true && "w-8 h-8 bg-green-500", isActive === false && isHover === false && "bg-gray-300", isActive === false && isHover === true && "bg-green-500"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("font-bold text-base", isActive === false && "sr-only", isActive === true && "text-white"),
                    children: step
                })
            })
        })
    });
}
function PartnersApplicationStep(param) {
    var step = param.step, isActive = param.isActive, onClick = param.onClick, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useHover/* default */.Z)(), 2), target = ref[0], isHovering = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        ref: target,
        onClick: onClick,
        className: "relative flex flex-col items-center px-10 py-8 space-y-4 focus:outline-none lg:px-12 lg:py-0",
        type: "button",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersApplicationStepBullet, {
                step: step,
                isActive: isActive,
                isHover: isHovering
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("text-base font-medium", isActive === false && "text-gray-600", isActive === true && "text-gray-900"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "leading-relaxed",
                    children: children
                })
            })
        ]
    });
}
function PartnersApplicationSteps() {
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 gap-10 divide-y-2 divide-gray-100 lg:grid-cols-3 lg:divide-y-0 lg:divide-x-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersApplicationStep, {
                    step: 1,
                    isActive: active === 0,
                    onClick: function() {
                        return setActive(0);
                    },
                    children: "Completa el formulario expresando tu inter\xe9s en hacerte socio"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersApplicationStep, {
                    step: 2,
                    isActive: active === 1,
                    onClick: function() {
                        return setActive(1);
                    },
                    children: "Recibimos tu solicitud y la revisamos para tomar una decisi\xf3n"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersApplicationStep, {
                    step: 3,
                    isActive: active === 2,
                    onClick: function() {
                        return setActive(2);
                    },
                    children: "Una vez aprobada la solicitud nos comunicamos contigo"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(6654);
// EXTERNAL MODULE: ./src/hooks/useTimeout.js
var useTimeout = __webpack_require__(11083);
// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
;// CONCATENATED MODULE: ./src/domain/Partners/PartnersLogosAnimation.js







function ParnetLogoGridCell(param) {
    var colStart = param.colStart, rowStart = param.rowStart, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("flex items-center justify-center relative", colStart, rowStart),
        children: children
    });
}
function PartnerLogo(param) {
    var src = param.src, brandName = param.brandName, transitionDelay = param.transitionDelay, animation = param.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
        enter: (0,clsx_m/* default */.Z)("transition transform ease-linear duration-700", transitionDelay),
        enterFrom: "opacity-0 scale-50",
        enterTo: "opacity-100 scale-100",
        leave: (0,clsx_m/* default */.Z)("transition transform ease-linear duration-700", transitionDelay),
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            tooltip: brandName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)("cursor-pointer block w-20 h-20 focus:outline-none rounded-full shadow-xl", animation),
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                    className: "rounded-full",
                    src: src,
                    width: 180,
                    height: 180,
                    alt: brandName
                })
            })
        })
    });
}
function PartnersLogosAnimation() {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    (0,useTimeout/* default */.Z)(function() {
        return setShow(true);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute z-20 inset-0 grid grid-cols-12 grid-rows-12 lg:my-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition_esm/* Transition */.u, {
            show: show,
            className: "col-span-12 grid grid-cols-6 grid-rows-6 gap-2 p-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-2",
                    rowStart: "row-start-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275133/socios/klever_lchrdl.png",
                        brandName: "Klever Team",
                        transitionDelay: "delay-100",
                        animation: "animate-float-random-1"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-3",
                    rowStart: "row-start-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275132/socios/certificate-en-scrum_qru8vy.png",
                        brandName: "Certif\xedcate en Scrum",
                        transitionDelay: "delay-100",
                        animation: "animate-float-random-2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-5",
                    rowStart: "row-start-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275132/socios/cobalto-consulting_s2ysou.png",
                        brandName: "Cobalto Consulting",
                        transitionDelay: "delay-150",
                        animation: "animate-float-random-3"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-4",
                    rowStart: "row-start-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275132/socios/digital-boost_idohzl.png",
                        brandName: "DigitalBoost",
                        transitionDelay: "delay-300",
                        animation: "animate-float-random-6"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-2",
                    rowStart: "row-start-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275133/socios/fm-consulting_uovthk.png",
                        brandName: "F&M Consulting",
                        transitionDelay: "delay-200",
                        animation: "animate-float-random-4"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-6",
                    rowStart: "row-start-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275133/socios/ge-360_ypai0g.png",
                        brandName: "Grupo Empresarial 360",
                        transitionDelay: "delay-200",
                        animation: "animate-float-random-5"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParnetLogoGridCell, {
                    colStart: "col-start-6",
                    rowStart: "row-start-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                        src: "v1612275133/socios/neuronforest_ldarsa.png",
                        brandName: "Neuron Forest",
                        transitionDelay: "delay-300",
                        animation: "animate-float-random-7"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Partners/PartnersHeroAnimation.js





function PartnersHeroAnimation() {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    (0,useTimeout/* default */.Z)(function() {
        return setShow(true);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden md:block absolute top-0 bottom-0 right-0 w-3/5 z-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersLogosAnimation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                show: show,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                    enter: "transition-opacity duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-opacity duration-300 transform",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-full absolute z-0 top-0 right-0 transform translate-x-48 origin-top -mt-20 bg-green-200",
                        style: {
                            width: "870px",
                            height: "870px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute z-10 rounded-full bg-green-300 flex items-center justify-center",
                                style: {
                                    width: "596px",
                                    height: "596px",
                                    top: "136px",
                                    left: "136px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "animate-spin-slow absolute border border-white rounded-full",
                                        style: {
                                            width: "466px",
                                            height: "466px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    top: "-8px",
                                                    left: "233px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    top: "80px",
                                                    left: "41px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    bottom: "80px",
                                                    left: "41px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    bottom: "-8px",
                                                    left: "233px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    top: "80px",
                                                    right: "41px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    bottom: "80px",
                                                    right: "41px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    top: "233px",
                                                    right: "-8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute w-4 h-4 rounded-full bg-white",
                                                style: {
                                                    top: "233px",
                                                    left: "-8px"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-3/6 h-3/6 shadow-outside-light-lg flex relative z-50 rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full h-full rounded-full relative flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "opacity-40 absolute inset-0 bg-green-500 rounded-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo, {
                                                    src: "v1612275132/socios/aibes_fntveq.png",
                                                    brandName: "Asociaci\xf3n Iberoamericana de Scrum",
                                                    transitionDelay: "delay-75",
                                                    animation: "animate-float-random-1"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "animate-spin-backwords-slow absolute z-0 left-0 top-0 border border-white rounded-full",
                                style: {
                                    width: "740px",
                                    height: "740px",
                                    left: "60px",
                                    top: "60px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            top: "-8px",
                                            left: "370px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            top: "80px",
                                            left: "120px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            bottom: "80px",
                                            left: "120px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            bottom: "-8px",
                                            left: "370px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            top: "80px",
                                            right: "120px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            bottom: "80px",
                                            right: "41px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            top: "370px",
                                            right: "-8px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-4 h-4 rounded-full bg-white",
                                        style: {
                                            top: "370px",
                                            left: "-8px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/helpers/uniqueKey.js
var uniqueKey = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/domain/Testimonials/TestimonialSlideButton.js



var TestimonialSlideButton_defaultProps = {};
var TestimonialSlideButton_propTypes = {
    label: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).node.isRequired
};
function TestimonialSlideButton(param) {
    var label = param.label, className = param.className, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("z-20 absolute bottom-0 top-0 flex items-center", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: onClick,
            className: "bg-white shadow w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-full transition ease-in-out duration-300 focus:outline-none hover:shadow-lg transform hover:-translate-y-1 hover:text-gray-400",
            type: "button",
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sr-only",
                    children: label
                })
            ]
        })
    });
};
TestimonialSlideButton.defaultProps = TestimonialSlideButton_defaultProps;
TestimonialSlideButton.propTypes = TestimonialSlideButton_propTypes;

;// CONCATENATED MODULE: ./src/domain/Testimonials/TestimonialSlidePrevButton.js




function TestimonialSlidePrevButton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlideButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "left-0 -ml-5 lg:-ml-6",
        label: "Anterior"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-6 h-6",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
                clipRule: "evenodd"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/domain/Testimonials/TestimonialSlideNextButton.js




function TestimonialSlideNextButton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlideButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "right-0 -mr-5 lg:-mr-6",
        label: "Siguiente"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-6 h-6",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                clipRule: "evenodd"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/domain/Testimonials/TestimonialSlideLogoWrapper.js




var TestimonialSlideLogoWrapper_defaultProps = {
    isActive: false
};
var TestimonialSlideLogoWrapper_propTypes = {
    isActive: (prop_types_default()).bool,
    bgColor: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
function TestimonialSlideLogoWrapper(param) {
    var isActive = param.isActive, bgColor = param.bgColor, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
        show: isActive,
        enter: "transition-opacity duration-700",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-500",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: (0,clsx_m/* default */.Z)("px-10 flex items-center justify-center absolute inset-0", bgColor),
            children: children
        })
    });
};
TestimonialSlideLogoWrapper.defaultProps = TestimonialSlideLogoWrapper_defaultProps;
TestimonialSlideLogoWrapper.propTypes = TestimonialSlideLogoWrapper_propTypes;

;// CONCATENATED MODULE: ./src/domain/Testimonials/TestimonialSlides.js








var TestimonialSlides_defaultProps = {};
var TestimonialSlides_propTypes = {
    testimonials: prop_types_default().arrayOf(prop_types_default().shape({
        logo: (prop_types_default()).node.isRequired,
        bgColor: (prop_types_default()).string.isRequired,
        testimonial: (prop_types_default()).string.isRequired,
        who: (prop_types_default()).string.isRequired,
        whoPosition: (prop_types_default()).string.isRequired,
        partner: (prop_types_default()).string.isRequired,
        partnerLink: (prop_types_default()).string.isRequired
    })).isRequired
};
function TestimonialSlides(param) {
    var testimonials = param.testimonials;
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var goPrev = (0,react.useCallback)(function() {
        setActive(function(ix) {
            if (ix > 0) {
                return ix - 1;
            }
            return 0;
        });
    }, []);
    var goNext = (0,react.useCallback)(function() {
        setActive(function(ix) {
            if (ix < 1) {
                return ix + 1;
            }
            return 0;
        });
    }, []);
    var totalSlides = testimonials.length;
    var translateValue = active === 0 ? "0%" : "-".concat(active * 100 / totalSlides, "%");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded-lg xl:rounded-xl bg-white shadow-lg lg:shadow-2xl relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlidePrevButton, {
                onClick: goPrev
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlideNextButton, {
                onClick: goNext
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-12 w-full overflow-hidden relative z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: "lg:col-span-4 overflow-hidden flex h-52 lg:h-auto rounded-t-lg lg:rounded-t-none lg:rounded-l-lg xl:rounded-l-xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "list-none flex relative w-full transition transform",
                            children: testimonials.map(function(t, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlideLogoWrapper, {
                                    isActive: active === index,
                                    bgColor: t.bgColor,
                                    children: t.logo
                                }, (0,uniqueKey/* default */.Z)("testimonial-logo-".concat(index)));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:col-span-8 overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            style: {
                                transform: "translateX(".concat(translateValue, ")"),
                                width: "200%"
                            },
                            className: "flex transition-transform duration-500 ease-in-out",
                            children: testimonials.map(function(t, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "p-10 lg:py-20 lg:px-20",
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "45",
                                                        height: "36",
                                                        className: "mb-5 fill-current text-gray-200",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "font-medium text-gray-800 text-lg lg:text-xl",
                                                        children: t.testimonial
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "text-gray-900 font-semibold text-lg",
                                                        children: t.who
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-gray-500",
                                                        children: [
                                                            t.whoPosition,
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                className: "text-gray-800 font-medium",
                                                                href: t.partnerLink,
                                                                children: t.partner
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, (0,uniqueKey/* default */.Z)("testimonial-".concat(index)));
                            })
                        })
                    })
                ]
            })
        ]
    });
};
TestimonialSlides.defaultProps = TestimonialSlides_defaultProps;
TestimonialSlides.propTypes = TestimonialSlides_propTypes;

;// CONCATENATED MODULE: ./src/domain/Partners/testimonials.js


var ge360 = {
    bgColor: "bg-blue-600",
    logo: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "w-32 h-32",
        width: "196",
        height: "196",
        viewBox: "0 0 196 196",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.237 33.758L101.23 0L107.48 0.686005C130.91 3.26001 151.438 13.381 167.797 30.425C177.365 40.394 184.984 52.338 189.191 63.964C192.055 71.878 195.23 86.561 195.23 91.889V94.258L161.73 94.251L160.104 85.868C157.517 72.527 152.529 63.339 142.339 53.149C132.149 42.959 122.961 37.971 109.62 35.384L101.237 33.758Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M41.589 89.117C42.368 81.639 45.451 73.653 50.444 66.175L54.525 60.064L78.592 84.13L77.286 88.087C76.5159 90.4208 76.1152 91.9142 75.1717 92.8737C73.3818 94.6937 69.6381 94.5922 57.712 94.661L41.001 94.758L41.589 89.117Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M116.986 85.273L128.358 73.333C134.613 66.765 140.045 61.362 140.429 61.325C141.504 61.222 145.726 67.197 148.507 72.758C151.609 78.962 154.23 87.63 154.231 91.69V94.758L120.73 94.294L116.986 85.273Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.252 97.72C81.214 92.488 85.21 86.116 90.137 83.552C95.715 80.649 99.768 80.651 105.27 83.561C110.208 86.172 114.23 92.545 114.23 97.758C114.23 106.511 105.105 114.884 96.562 113.969C88.076 113.06 81.311 105.88 81.252 97.72Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M44.309 117.738C43.216 114.817 42.0179 110.139 41.647 107.343L40.972 102.258H74.831L79.366 111.592L67.564 123.425C61.072 129.933 55.407 135.258 54.974 135.258C53.6509 135.258 46.418 123.377 44.309 117.738Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M117.263 109.197C117.794 108.204 118.668 106.237 119.204 104.825L120.18 102.258H137.205C154.197 102.258 154.23 102.262 154.218 104.508C154.183 111.188 147.882 126.611 142.676 132.758L140.136 135.758L128.217 123.379C118.295 113.075 116.459 110.698 117.263 109.197Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.98 194.83C42.143 189.794 6.42096 154.657 0.715942 108.995L0 103.258H33.889L35.595 111.194C40.909 135.925 60.659 155.247 85.559 160.077L94.223 161.758L94.23 195.516L87.98 194.83Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M142.838 142.215C151.069 134.017 156.809 123.746 159.534 112.337L161.703 103.258H195.418L194.741 108.508C192.694 124.385 187.637 138.266 179.316 150.851C163.036 175.47 137.241 191.452 108.48 194.74L102.23 195.454V161.604L108.825 160.388C122.37 157.893 132.564 152.446 142.838 142.215Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M60.73 141.336L72.714 129.297C79.306 122.676 84.916 117.258 85.181 117.258C85.446 117.258 87.591 117.994 89.947 118.894L94.23 120.53V154.258H91.624C84.587 154.258 70.291 148.724 63.23 143.268L60.73 141.336Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-current text-blue-200",
                d: "M102.23 120.264L105.48 118.842C107.268 118.061 109.187 117.384 109.746 117.34C110.304 117.295 116.122 122.633 122.675 129.203L134.588 141.147L132.159 143.199C126.536 147.949 110.843 154.213 104.48 154.246C102.234 154.258 102.23 154.224 102.23 137.261V120.264Z",
                fill: "white"
            })
        ]
    }),
    testimonial: "Contar con el respaldo de las certificaciones de la Asociaci\xf3n Iberoamericana de Scrum, no es solo importante para GE 360, sino tambi\xe9n para nuestros clientes, pues nos permite entregar entrenamientos de la m\xe1s alta calidad y el mejor reconocimiento profesional en temas de Agilidad para nuestra regi\xf3n.",
    who: "Federico Vargas",
    whoPosition: "CEO en",
    partner: "Grupo Empresarial 360",
    partnerLink: "/socios/grupo-empresarial-360"
};
var fymConsulting = {
    bgColor: "bg-blue-100",
    logo: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-64",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
            alt: "F & M Consulting",
            src: "v1616676234/socios/f_m_mzshhk.webp",
            width: "1168",
            height: "212"
        })
    }),
    testimonial: "Contar con el respaldo de la marca AIBES en F & M Consulting nos llena de mucha satisfacci\xf3n, pues tenemos la convicci\xf3n de que entregamos entrenamientos y certificaciones con el respaldo de una marca que vela por el cumplimiento de altos est\xe1ndares de calidad en sus procesos de formaci\xf3n y entrega de contenidos.",
    who: "Erick Masgo D\xe1vila",
    whoPosition: "Gerente General en",
    partner: "F&M Consulting",
    partnerLink: "/socios/fm-consulting"
};

;// CONCATENATED MODULE: ./src/domain/Partners/PartnersTestimonials.js



function PartnersTestimonials() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlides, {
        testimonials: [
            ge360,
            fymConsulting
        ]
    });
};

// EXTERNAL MODULE: ./src/domain/CustomerLogos/index.js + 1 modules
var CustomerLogos = __webpack_require__(23638);
// EXTERNAL MODULE: ./src/domain/customers/index.js
var customers = __webpack_require__(77390);
;// CONCATENATED MODULE: ./src/domain/Partners/PartnersClientBrands.js



function PartnersClientBrands() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-center py-10 bg-gradient-to-t from-gray-200 to-gray-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "sr-only",
                children: "Socios"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogos/* default */.Z, {
                customers: [
                    customers/* udla */.Dt,
                    customers/* iess */.P$,
                    customers/* soyHincha */.el,
                    customers/* nestle */.pQ,
                    customers/* soltein */.bR,
                    customers/* modernaAlimentos */.Vq, 
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Forms/index.js + 26 modules
var Forms = __webpack_require__(91212);
// EXTERNAL MODULE: ./src/components/Toaster/index.js + 4 modules
var Toaster = __webpack_require__(19232);
;// CONCATENATED MODULE: ./src/domain/Forms/PartnerApplyForm.js




var PartnerApplyForm_defaultProps = {
    onSuccess: function() {
        return (0,Toaster/* notifySuccess */.t5)("\n    Tu mensaje se ha enviado. Uno de nuestros agentes se\n    estar\xe1 poniendo en contacto lo m\xe1s pronto posible.\n  ");
    },
    onError: function() {
        return (0,Toaster/* notifyError */.cB)("\n    Ha ocurrido un error cuando intentamos enviar tu mensaje.\n    Por favor int\xe9ntalo nuevamente.\n  ");
    }
};
var PartnerApplyForm_propTypes = {
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};
function PartnerApplyForm(param) {
    var onSuccess = param.onSuccess, onError = param.onError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* default */.ZP, {
        initialValues: {
            firstname: "",
            lastname: "",
            company: "",
            email: "",
            country: "",
            phone: "",
            message: ""
        },
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
            (0,Forms/* submitForm */.R2)("7663692/4e9c01cd-4011-467b-bf36-8a26d9673782", values, {
                setSubmitting: setSubmitting,
                onSuccess: function onSuccess1() {
                    resetForm();
                    onSuccess();
                },
                onError: function onError1(errors) {
                    onError();
                }
            });
        },
        children: function(param) {
            var handleChange = param.handleChange, handleBlur = param.handleBlur, setFieldValue = param.setFieldValue, validateForm = param.validateForm, isSubmitting = param.isSubmitting, errors = param.errors, touched = param.touched, values = param.values;
            var countryHasError = touched.country && errors.country !== undefined;
            var phoneHasError = touched.phone && errors.phone !== undefined;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-4 lg:space-y-6 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-1 space-y-4 lg:space-y-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                        htmlFor: "firstname",
                                        label: "Nombres",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                            id: "firstname",
                                            name: "firstname",
                                            placeholder: "Juan",
                                            onChange: handleChange,
                                            value: values.firstname,
                                            disabled: isSubmitting,
                                            required: true
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-1 space-y-4 lg:space-y-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                        htmlFor: "lastname",
                                        label: "Apellidos",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                            id: "lastname",
                                            name: "lastname",
                                            placeholder: "D\xedaz",
                                            onChange: handleChange,
                                            value: values.lastname,
                                            disabled: isSubmitting,
                                            required: true
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "company",
                            label: "Empresa",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                id: "company",
                                name: "company",
                                placeholder: "Agile Company",
                                onChange: handleChange,
                                value: values.company,
                                disabled: isSubmitting,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "email",
                            label: "Correo electr\xf3nico de trabajo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* EmailFieldControl */.MG, {
                                id: "email",
                                name: "email",
                                placeholder: "juan.diaz@ejemplo.com",
                                onChange: handleChange,
                                value: values.email,
                                disabled: isSubmitting,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "phone",
                            label: "Tel\xe9fono",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* PhoneFieldControl */.gM, {
                                id: "phone",
                                name: "phone",
                                placeholder: "+5 (555) 555-5555",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.phone,
                                disabled: isSubmitting,
                                error: errors.phone,
                                hasError: phoneHasError,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "country",
                            label: "Pa\xeds",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* CountryFieldControl */.n8, {
                                htmlId: "country",
                                name: "country",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                setFieldValue: setFieldValue,
                                validateForm: validateForm,
                                value: values.country,
                                disabled: isSubmitting,
                                error: errors.country,
                                hasError: countryHasError,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "message",
                            label: "Mensaje",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextAreaControl */.ND, {
                                id: "message",
                                name: "message",
                                onChange: handleChange,
                                value: values.message,
                                disabled: isSubmitting
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormActions */.iN, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormSubmit */.Ow, {
                            label: "Comenzar el proceso",
                            submitting: isSubmitting
                        })
                    })
                ]
            });
        }
    });
};
PartnerApplyForm.defaultProps = PartnerApplyForm_defaultProps;
PartnerApplyForm.propTypes = PartnerApplyForm_propTypes;

;// CONCATENATED MODULE: ./src/pages/programa-de-socios/index.js
















function PartnersProgramPage() {
    var whomPartnerWithUsRef = (0,react.useRef)(null);
    var whyPartnerWithUsRef = (0,react.useRef)(null);
    var programDetailsRef = (0,react.useRef)(null);
    var sectionRefs = [
        whomPartnerWithUsRef,
        whyPartnerWithUsRef,
        programDetailsRef, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* default */.Z, {
        offset: -100,
        sectionRefs: sectionRefs,
        children: function(param) {
            var currentElementIndexInViewport = param.currentElementIndexInViewport;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-gray-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative overflow-hidden bg-gradient-to-tl from-green-200 to-green-50 py-10 lg:py-20 xl:py-32",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                className: "py-10 md:py-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative z-20 space-y-6 lg:col-span-6 lg:pr-20",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                heading: "Programa de socios"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "font-display text-4xl font-extrabold tracking-tight lg:text-5xl",
                                                children: "Hagamos crecer juntos la gran familia que somos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg leading-relaxed text-gray-600 lg:pr-10",
                                                children: "Como parte de nuestra comunidad global, con nuestros socios trabajamos juntos para acelerar el impacto en la adopci\xf3n de la cultura \xe1gil de nuestros clientes, mejorar sus habilidades y obtener m\xe1s y mejores resultados."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersHeroAnimation, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative top-0 z-30 bg-white shadow-sm lg:sticky",
                        style: {
                            backdropFilter: "blur(20px) saturate(120%)",
                            backgroundColor: "rgba(255, 255, 255, 0.5)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                            className: "overflow-x-auto overflow-y-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center space-x-10 md:justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center space-x-4 lg:-mb-px lg:space-x-10 xl:space-x-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                                anchor: "quien-se-asocia",
                                                label: "\xbfQui\xe9n se asocia con nosotros?",
                                                targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                                className: currentElementIndexInViewport === 0 ? "border-green-500 text-green-500" : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                                anchor: "por-que-asociarse",
                                                label: "\xbfPor qu\xe9 asociarse con nosotros?",
                                                targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                                className: currentElementIndexInViewport === 1 ? "border-green-500 text-green-500" : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                                anchor: "detalles-del-programa",
                                                label: "Detalles del programa",
                                                targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                                className: currentElementIndexInViewport === 2 ? "border-green-500 text-green-500" : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#aplicar",
                                            className: "flex items-center whitespace-nowrap rounded-full bg-green-500 px-5 py-3 font-semibold leading-3 text-white transition duration-100 ease-in-out hover:bg-green-600 focus:bg-green-600 focus:ring-4 focus:ring-green-800 focus:ring-opacity-20",
                                            role: "button",
                                            children: "Aplica y hazte socio"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "quien-se-asocia",
                        className: "relative z-10",
                        ref: whomPartnerWithUsRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-10 bg-gradient-to-b from-gray-100 to-white py-10 lg:space-y-28 lg:py-20 xl:py-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                        className: "space-y-10 lg:space-y-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-center space-y-4 text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        className: "h-20 w-20",
                                                        width: "48",
                                                        height: "48",
                                                        viewBox: "0 0 48 48",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-200",
                                                                d: "M41,11V41H7V11H5V7H43v4H41Z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "vi-accent fill-current text-green-500",
                                                                d: "M38.5,18c-4.3,0-4.5-5-4.5-5a5,5,0,0,1-10,0,5,5,0,0,1-10,0s-0.2,5-4.5,5A4.5,4.5,0,0,1,5,13.5V11H43v2.5A4.5,4.5,0,0,1,38.5,18ZM22.01,35.01h-9V25.99h9v9.02ZM34.993,41h-8V25.99h8V41Z"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SecondaryTitle, {
                                                    className: "",
                                                    children: "\xbfQui\xe9n se asocia con nosotros?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "grid grid-cols-1 lg:grid-cols-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                                                        className: "lg:col-span-8 lg:col-start-3",
                                                        children: "Organizaciones, empresas y personas que impulsan la adopci\xf3n de la cultura \xe1gil en toda la regi\xf3n hispanohablante."
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-10 lg:col-span-7 lg:py-10 lg:pr-10",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                                    heading: "Red de socios"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "space-y-4 lg:space-y-6",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            className: "text-3xl font-extrabold leading-relaxed tracking-tight md:font-semibold lg:pr-32",
                                                                            children: "Construyendo alianzas duraderas para liderar el cambio"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "space-y-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                                    className: "text-lg leading-relaxed text-gray-700",
                                                                                    children: "Una asociaci\xf3n con nosotros es la forma m\xe1s inteligente para influir en la comunidad hispanohablante apasionada por la cultura \xe1gil."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                                    className: "text-lg leading-relaxed text-gray-700",
                                                                                    children: "La asociaci\xf3n con AIBES te ayudar\xe1 a generar nuevas oportunidades, liderar el cambio hacia la adopci\xf3n de la cultura \xe1gil y expandirte internacionalmente."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkMore, {
                                                            href: "/socios",
                                                            children: "Conoce a nuestros socios"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative lg:col-span-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex rounded-lg shadow-lg lg:rounded-xl lg:shadow-xl",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                            className: "h-full w-full rounded-lg object-cover",
                                                            src: "v1612308818/socios/red-de-socios_jpd5wp.jpg",
                                                            alt: "Red de socios",
                                                            width: 600,
                                                            height: 700
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersClientBrands, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative bg-gradient-to-tr from-gray-100 to-white py-10 lg:py-20 xl:py-32",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                    className: "relative z-10 space-y-10 lg:space-y-20",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative lg:col-span-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex rounded-lg shadow-lg lg:rounded-xl lg:shadow-xl",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                        className: "h-full w-full rounded-lg object-cover lg:rounded-xl",
                                                        src: "v1612308818/socios/red-de-entrenadores_ntpxfp.jpg",
                                                        alt: "Red de entrenadores",
                                                        width: 700,
                                                        height: 600
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-10 lg:col-span-7 lg:py-10 lg:pl-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                                heading: "Socios entrenadores"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "space-y-4 lg:space-y-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "text-3xl font-extrabold leading-relaxed tracking-tight md:font-semibold",
                                                                        children: "Profesionales del m\xe1s alto nivel que desarrollan su carrera con nuestro programa"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                        className: "text-lg leading-relaxed text-gray-700",
                                                                        children: "Contamos con entrenadores con vasta experiencia y conocimientos demostrados. Reconocidos referentes en la regi\xf3n por su contribuci\xf3n y desarrollo en procesos de transformaci\xf3n organizacional."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkMore, {
                                                        href: "/entrenadores",
                                                        children: "Conoce a nuestros entrenadores"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "por-que-asociarse",
                        className: "relative z-20 bg-white bg-gradient-to-t from-gray-100 to-white py-10 lg:pt-20 xl:pt-32",
                        ref: whyPartnerWithUsRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                            className: "space-y-10 lg:space-y-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center space-y-4 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: "h-20 w-20",
                                                width: "48",
                                                height: "48",
                                                viewBox: "0 0 48 48",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "fill-current text-green-200",
                                                        d: "M24,41L11,33V22H37V33ZM6,34a2.993,2.993,0,0,1-1-5.816V20l2,1v7.184A2.993,2.993,0,0,1,6,34Z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "fill-current text-green-500",
                                                        d: "M24,7.012l21.986,12.5L24,32.013,2.014,19.513Z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SecondaryTitle, {
                                            className: "",
                                            children: "\xbfPor qu\xe9 asociarse con nosotros?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-1 lg:grid-cols-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                                                className: "lg:col-span-8 lg:col-start-3",
                                                children: "Nuestro programa de socios est\xe1 dise\xf1ado para colaborar en la creaci\xf3n de nuevas oportunidades, liderar el cambio hacia la adopci\xf3n de la cultura \xe1gil y expandirte internacionalmente, principalmente a las comunidades hispanohablantes."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col pt-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-6 lg:col-span-7 lg:space-y-10 lg:py-10 lg:pr-20",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-4 lg:space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-xl font-semibold leading-relaxed tracking-tight lg:text-3xl",
                                                                children: "Gran impacto para equipos de todos los tama\xf1os y en cualquier lugar"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                className: "text-lg leading-relaxed text-gray-700",
                                                                children: "Asociarte con nosotros significa contar profesionales competentes en la adopci\xf3n de la cultura \xe1gil, con el respaldo de programas de entrenamientos internacionales, entrenadores de primer nivel y certificaciones reconocidas y v\xe1lidas mundialmente."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "grid grid-cols-1 gap-3 text-lg leading-7 text-gray-600 lg:pr-20",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex items-start space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                        className: "mt-px text-green-500"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-1",
                                                                        children: "Acceso a materiales de calidad unificados"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex items-start space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                        className: "mt-px text-green-500"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-1",
                                                                        children: "Acceso a entrenadores internacionales reconocidos como referentes en la regi\xf3n"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex items-start space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                        className: "mt-px text-green-500"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-1",
                                                                        children: "Certificaciones reconocidas a nivel internacional, basadas en el Manifiesto \xc1gil"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex items-start space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                        className: "mt-px text-green-500"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-1",
                                                                        children: "Acceso a la plataforma virtual en la que se utilizan m\xe9todos innovadores, con materiales, programas, casos de estudio y buenas pr\xe1cticas"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex items-start space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                        className: "mt-px text-green-500"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-1",
                                                                        children: "Simuladores de los ex\xe1menes de certificaci\xf3n"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative flex lg:col-span-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex rounded-lg shadow-lg lg:rounded-xl lg:shadow-xl",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                        className: "h-full w-full rounded-lg object-cover lg:rounded-xl",
                                                        src: "v1612308816/socios/programa-de-socios_p0hovd.jpg",
                                                        alt: "Programa de socios",
                                                        width: 700,
                                                        height: 600
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersTestimonials, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "detalles-del-programa",
                        className: "relative z-10 bg-gradient-to-b from-gray-100 to-white py-10 lg:py-20 xl:py-32",
                        ref: programDetailsRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                            className: "space-y-10 lg:space-y-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center space-y-4 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: "h-20 w-20",
                                                width: "48",
                                                height: "48",
                                                viewBox: "0 0 48 48",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "fill-current text-green-200",
                                                        d: "M29.624,43.785L25.381,32.472l7.778-7.778,2.075,8.735ZM4.168,18.329l10.357-5.611,8.735,2.075-7.778,7.778ZM5.624,34.991c1.92-4.929,5.24-2.274,5.24-2.274l2.222,2.217,2.2,2.193s2.627,3.28-2.295,5.213a12.725,12.725,0,0,1-4.578.376c-0.815-.076-3.537,1.6-4.347,1.222-0.39-.814,1.288-3.537,1.207-4.355A12.681,12.681,0,0,1,5.624,34.991Z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "fill-current text-green-500",
                                                        d: "M10.7,24.537C29.323,6.122,43.983,3.986,43.983,3.986S41.823,18.484,23.2,36.9c0,0-4.841,5.327-11.38-1.14A8.244,8.244,0,0,1,10.7,24.537Z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "fill-current text-green-200",
                                                        d: "M27.646,20.336a4.454,4.454,0,1,1-6.346-.058A4.512,4.512,0,0,1,27.646,20.336Z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SecondaryTitle, {
                                            children: "\xdanete a nuestro programa de socios"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-1 lg:grid-cols-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                                                className: "lg:col-span-8 lg:col-start-3",
                                                children: "Trabajemos juntos para acelerar el impacto en la adopci\xf3n de la cultura \xe1gil de nuestros clientes y para ayudarles a obtener m\xe1s y mejores resultados."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-lg bg-white py-10 shadow-lg lg:shadow-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersApplicationSteps, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "aplicar",
                        className: "relative z-10 overflow-hidden bg-green-100 py-10 lg:py-20 xl:py-32",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                maxWidth: "max-w-screen-lg",
                                className: "relative z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-mx-4 rounded-2xl bg-white p-4 shadow-2xl md:mx-0 lg:p-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full space-y-10 py-10 lg:space-y-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-center text-lg font-semibold tracking-tight lg:text-3xl",
                                                children: "Aplica hoy y hazte nuestro socio"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:px-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerApplyForm, {})
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pointer-events-none absolute left-0 bottom-0 right-0 h-2/4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0 -skew-y-6 transform bg-gray-900"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute left-0 bottom-0 right-0 h-2/4 bg-gray-900"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
PartnersProgramPage.layoutProps = {
    stickyHeader: false
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,5675,2175,6225,1684,1212,9774,2888,179], function() { return __webpack_exec__(43518); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);